/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfileData/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Age from './Age/index'
import AgeGenderSeparator from './AgeGenderSeparator/index'
import DateOfBirth from './DateOfBirth/index'
import Gender from './Gender/index'
import GenderBirthSeparator from './GenderBirthSeparator/index'
import HumanId from './HumanId/index'
import Name from './Name/index'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import Tag from './Tag/index'
import TysiaIconPersonFilled from 'DesignSystem/Svgs/TysiaIconPersonFilled/index'
import styles from './view.module.css'
let Locations = React.lazy(() => import('./Locations/index'))



/** @type {import('Simple/types.js').View} */
export default function ProfileData({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/Emails/Content/Email/Edit/Content/EditOrAdd/Content/Content/Profiles/Content/Profile/ProfileData"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="ProfileData.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-2bfKmT': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ProfileData.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Tag
  viewPath={`${viewPath}/Tag`}
/>
</div>
<div
  data-testid="ProfileData.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconPersonFilled
  viewPath={`${viewPath}/TysiaIconPersonFilled`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill={dtColorsNeutral600}
/>
<Age
  viewPath={`${viewPath}/Age`}
/>
<AgeGenderSeparator
  viewPath={`${viewPath}/AgeGenderSeparator`}
/>
<Gender
  viewPath={`${viewPath}/Gender`}
/>
<GenderBirthSeparator
  viewPath={`${viewPath}/GenderBirthSeparator`}
/>
<DateOfBirth
  viewPath={`${viewPath}/DateOfBirth`}
/>
</div>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<Locations
{...childProps}
  viewPath={`${viewPath}/Locations`}
/>
)}
</SuspenseBoundary>
<HumanId
  viewPath={`${viewPath}/HumanId`}
/>
</div>
{children}
</React.Fragment>)
}